import { IOpenProjectsDepositsReceived } from "financials/models";
import { Link } from "react-router-dom";
import { ColumnsType, ROW_INDEX_COLUMN } from "shared/constants";
import { utilityService } from "shared/services";
import { IOrganization } from "organizations/models";
import { buildOrganizationSectionPath } from "shared/utils/paths";

export const getOpenProjectsDepositsReceivedColumns = (organization: IOrganization | undefined): ColumnsType<IOpenProjectsDepositsReceived> =>
  [
    ROW_INDEX_COLUMN,
    {
      title: "Project",
      dataIndex: "projectName",
      render: (value, record, index) => (
        <Link to={buildOrganizationSectionPath(organization, `projects/${record.id}`)}>
          {utilityService.truncateField(value)}
        </Link>
      ),
    },
    {
      title: "Deposit Invoiced Date",
      dataIndex: "depositInvoicedDate",
      render: (value, record, index) => utilityService.dateFormatter(value),
    },
    {
      title: "ReceivedDate",
      dataIndex: "receivedDate",
      render: (value, record, index) => utilityService.dateFormatter(value),
    },
    {
      title: "Deposit Amount Received",
      dataIndex: "depositAmountReceived",
      render: (value, record, index) =>
        `$${utilityService.statisticsFormatter(value)}`,
    },
    {
      title: "Project Amount",
      dataIndex: "projectAmount",
      render: (value, record, index) =>
        `$${utilityService.statisticsFormatter(value)}`,
    },
  ];
